import * as React from 'react';
import { withStyles, Theme, WithStyles, createStyles } from '@material-ui/core';
import { Typography } from 'ha/ui/next/Typography';
import units from 'ha/theme/units';

export const styles = (t: Theme) =>
  createStyles({
    root: {
      fontSize: units.rem(1.25),
      fontWeight: 'bold',
      textTransform: 'none',
      whiteSpace: 'nowrap',
      color: 'inherit',
      lineHeight: 'inherit',

      [t.breakpoints.up('md')]: {
        fontSize: units.rem(1.875),
      },
    },
  });

export const Label: React.SFC<WithStyles<typeof styles>> = ({
  children,
  classes,
}) => <Typography.H3 className={classes.root}>{children}</Typography.H3>;

export default withStyles(styles)(Label);
